import React from 'react';

const Tester: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M65.69 25.29h-30.8a1.036 1.036 0 00-1.082 1.034V53.41a1.082 1.082 0 001.082 1.082h30.8a1.129 1.129 0 001.082-1.082V26.324a1.082 1.082 0 00-1.081-1.034zm-1.034 27.086H35.924v-24.97h28.732v24.97zm-18.338 5.871H34.891a1.083 1.083 0 100 2.116h11.427a1.034 1.034 0 001.035-1.035 1.035 1.035 0 00-1.035-1.081zm19.373 0H54.264a1.036 1.036 0 00-1.034 1.081 1.034 1.034 0 001.034 1.035h11.427a1.083 1.083 0 100-2.116z"
    ></path>
    <path
      fill="currentColor"
      d="M50.456 14C40.063 14 28.87 17.668 28.87 25.662v28.826a21.537 21.537 0 0015.048 20.55h.33a.893.893 0 00.564 0 1.082 1.082 0 00.47-.706 5.267 5.267 0 015.173-4.467 5.173 5.173 0 015.125 4.467.988.988 0 00.518.706.893.893 0 00.846 0 21.49 21.49 0 0014.86-20.55V25.662C71.805 17.668 60.848 14 50.455 14zm19.42 40.488a19.327 19.327 0 01-12.46 18.198 7.336 7.336 0 00-14.108 0 19.374 19.374 0 01-12.509-18.15V25.661c0-6.254 9.782-9.405 19.469-9.405 4.672-.11 9.317.754 13.637 2.54a8.465 8.465 0 015.972 6.865v28.826z"
    ></path>
    <path
      fill="currentColor"
      d="M52.995 86.794H47.87a1.031 1.031 0 01-.97-.671 1.034 1.034 0 01-.065-.41V72.686a1.034 1.034 0 011.035-1.035h5.125a1.035 1.035 0 011.082 1.035V85.9a1.082 1.082 0 01-1.082.894zm-4.044-2.116h3.01V73.674h-3.01v11.004zM50.22 49.83a10.017 10.017 0 115.502-18.34 1.05 1.05 0 11-1.176 1.74 7.758 7.758 0 00-4.326-1.27 7.9 7.9 0 107.9 7.806 8.649 8.649 0 000-1.552.987.987 0 01.8-1.222 1.036 1.036 0 011.269.799 14.12 14.12 0 010 1.975 10.017 10.017 0 01-9.97 10.063z"
    ></path>
    <path
      fill="currentColor"
      d="M50.22 44.47a1.082 1.082 0 01-.8-.47l-3.996-5.55a.987.987 0 010-1.457 1.033 1.033 0 011.458.235l3.197 4.467 8.559-9.97a.987.987 0 011.457 0 1.035 1.035 0 010 1.506l-9.404 11.003a.987.987 0 01-.47.236z"
    ></path>
  </svg>
);

export default Tester;
